require('../../modules/es7.string.trim-right');
module.exports = require('../../modules/_core').String.trimRight;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/trim-end.js
// module id = 144
// module chunks = 0